import useForm from 'hooks/form/useForm';
import React, { useEffect } from 'react';
import { RESET_PII_PROFILE_RESIDENTIAL_ADDRESS } from '../const';
import usePIIStore from '../hooks/usePIIStore';

const initialFormField = RESET_PII_PROFILE_RESIDENTIAL_ADDRESS;

const withFormPIIProfileResidentialAddressInitial = (Component) => {
  const FormPIIProfileResidentialAddressInitialComponent = (props) => {
    const { residentialAddress } = usePIIStore();

    const {
      information,
      setInformation,
      validation,
      setValidation,
      checkAllowSubmit,
    } = useForm(initialFormField);

    useEffect(() => {
      setInformation(residentialAddress);
    }, []);

    const newProps = {
      ...props,
      information,
      setInformation,
      validation,
      setValidation,
      checkAllowSubmit,
    };
    return <Component {...newProps} />;
  };
  return FormPIIProfileResidentialAddressInitialComponent;
};

export default withFormPIIProfileResidentialAddressInitial;
